{
  "name": "drillingllc",
  "version": "2026.21.0",
  "scripts": {
    "ng": "ng",
    "serve:jtms-front-end": "ng serve --project jtms-front-end",
    "serve:pressure-test": "ng serve --project pressure-test",
    "serve:torque-ui": "ng serve --project torque-ui",
    "serve:tool-grid": "ng serve --project elements",
    "serve:gatekeeper-assessment": "ng serve --project elements --configuration gatekeeper-assessment --port 4200",
    "build:jtms:production": "ng build --project jtms-front-end --configuration production",
    "build:jtms:staging": "ng build --project jtms-front-end --configuration staging",
    "build:pressure-test:production": "ng build --project pressure-test --configuration production",
    "build:pressure-test:staging": "ng build --project pressure-test --configuration staging",
    "build:torque-ui:production": "ng build --project torque-ui --configuration production",
    "build:production": "firebase dataconnect:sdk:generate && npm run build:jtms:production",
    "build:staging": "firebase dataconnect:sdk:generate && npm run build:jtms:staging",
    "build:elements:tool-grid": "ng build --project elements --configuration production --output-hashing none && node scripts/build-elements-tool-grid.js",
    "build:elements:gatekeeper-assessment": "ng build --project elements --configuration production,gatekeeper-assessment --output-hashing none && node scripts/build-elements-gatekeeper-assessment.js",
    "build:elements:gatekeeper-assessment-site": "ng build --project elements --configuration production,gatekeeper-assessment",
    "firebase:emulators:start": "firebase emulators:start --project rental-tool-manager --only dataconnect --import .emulators/data --export-on-exit .emulators/data",
    "mcp:check": "node scripts/mcp-sanity-check.js",
    "instructions:check": "node scripts/instructions-check.js",
    "setup:check": "node scripts/dev-setup-check.js",
    "watch": "ng build --watch --configuration development",
    "lint:frontend": "eslint \"projects/**/*.ts\" \"projects/**/*.html\"",
    "lint:frontend:strict:feature": "eslint --config eslint.strict.config.mjs \"projects/jtms-front-end/src/app/feature/**/*.ts\" \"projects/jtms-front-end/src/app/feature/**/*.html\"",
    "lint:frontend:strict:changed": "node scripts/lint-strict-changed.mjs",
    "test": "ng test",
    "test:ci:jtms-front-end": "ng test jtms-front-end --watch=false --browsers=ChromeHeadless --progress=false",
    "deploy:jtms:production": "firebase deploy --only hosting:jtms-production",
    "deploy:jtms:staging": "firebase deploy --only hosting:jtms-staging",
    "deploy:pressure-test:production": "firebase deploy --only hosting:pressure-test",
    "deploy:torque-ui:production": "firebase deploy --only hosting:torque",
    "deploy:gatekeeper-assessment": "npm run build:elements:gatekeeper-assessment-site && firebase deploy --only hosting:gatekeeper-assessment",
    "deploy:dis-elements": "npm run build:elements:tool-grid && npm run build:elements:gatekeeper-assessment && firebase deploy --only hosting:dis-elements",
    "sentry:jtms-front-end:sourcemaps": "sentry-cli sourcemaps inject --org drilling-innovative-systems --project jtms-front-end dist/jtms-front-end && ngsw-config dist/jtms-front-end/browser projects/jtms-front-end/ngsw-config.json && sentry-cli sourcemaps upload --org drilling-innovative-systems --project jtms-front-end dist/jtms-front-end",
    "sentry:pressure-test:sourcemaps": "sentry-cli sourcemaps inject --org drilling-innovative-systems --project pressure-test dist/pressure-test && sentry-cli sourcemaps upload --org drilling-innovative-systems --project pressure-test dist/pressure-test",
    "global:npm:update": "npm install -g @angular/cli firebase-tools@latest && env -u npm_config_allow_scripts npm install -D firebase-tools@latest"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "22.2.3",
    "@angular/cdk": "^22.2.4",
    "@angular/common": "22.2.3",
    "@angular/compiler": "22.2.3",
    "@angular/core": "22.2.3",
    "@angular/elements": "^22.2.3",
    "@angular/fire": "^20.0.1",
    "@angular/forms": "22.2.3",
    "@angular/material": "^22.2.4",
    "@angular/platform-browser": "22.2.3",
    "@angular/platform-browser-dynamic": "22.2.3",
    "@angular/router": "22.2.3",
    "@angular/service-worker": "22.2.3",
    "@dataconnect/public-connector": "file:dataconnect-generated/js/public-connector",
    "@dataconnect/realtime-connector": "file:dataconnect-generated/js/realtime-connector",
    "@jtms/default-connector": "file:dataconnect-generated/js/default-connector",
    "@ngxs/form-plugin": "^22.0.0",
    "@ngxs/router-plugin": "^22.0.0",
    "@ngxs/storage-plugin": "^22.0.0",
    "@ngxs/store": "^22.0.0",
    "@ngxs/websocket-plugin": "^22.0.0",
    "@sentry/angular": "^10.75.2",
    "@sentry/cli": "^3.8.2",
    "@tanstack-query-firebase/angular": "file:libs/tanstack-query-firebase-angular-1.0.2.tgz",
    "@tanstack/angular-db": "^0.2.12",
    "@tanstack/angular-form": "^1.33.5",
    "@tanstack/angular-query-experimental": "^5.104.5",
    "@tanstack/angular-table": "^9.3.1",
    "@tanstack/query-db-collection": "^1.4.8",
    "@zxing/browser": "^0.2.1",
    "@zxing/library": "^0.23.0",
    "@zxing/ngx-scanner": "^22.0.1",
    "ag-grid-angular": "^36.2.0",
    "ag-grid-enterprise": "^36.2.0",
    "angular-google-charts": "^16.1.0",
    "firebase": "^13.0.0",
    "html2canvas": "^1.4.1",
    "jspdf": "^4.2.1",
    "jsqr": "^1.4.0",
    "lodash-es": "^4.18.1",
    "mapbox-gl": "^3.33.0",
    "modern-screenshot": "^4.7.0",
    "ngx-doc-viewer": "^21.0.6",
    "ngx-mqtt": "^22.0.0",
    "ngx-observable-lifecycle": "^3.0.0",
    "ngx-print": "22.2.1",
    "ngx-signal-operators": "^0.4.0",
    "ngx-sub-form": "^15.0.0",
    "observable-webworker": "^6.0.1",
    "qrcode-generator": "2.0.4",
    "rxjs": "^7.8.2",
    "tslib": "^2.8.1",
    "zone.js": "^0.16.2"
  },
  "devDependencies": {
    "@angular-eslint/eslint-plugin": "^22.6.0",
    "@angular-eslint/eslint-plugin-template": "^22.6.0",
    "@angular-eslint/template-parser": "^22.6.0",
    "@angular/build": "^22.2.4",
    "@angular/cli": "~22.2.4",
    "@angular/compiler-cli": "^22.2.3",
    "@commitlint/cli": "^21.2.4",
    "@commitlint/config-conventional": "^21.2.4",
    "@eslint/js": "^9.39.1",
    "@ngxs/devtools-plugin": "^22.0.0",
    "@tailwindcss/postcss": "^4.3.3",
    "@types/gapi": "0.0.47",
    "@types/gapi.client.chat-v1": "^0.0.4",
    "@types/gapi.client.discovery-v1": "^0.0.4",
    "@types/gapi.client.drive-v3": "^0.0.5",
    "@types/gapi.client.script-v1": "^0.0.4",
    "@types/gapi.client.sheets-v4": "^0.0.4",
    "@types/geojson": "^7946.0.16",
    "@types/jasmine": "~6.0.0",
    "@types/node": "^26.6.5",
    "angular-eslint": "^22.6.0",
    "baseline-browser-mapping": "^2.11.32",
    "concat": "^1.0.3",
    "eslint": "^9.39.1",
    "firebase-tools": "^15.34.1",
    "fs-extra": "^11.4.1",
    "istanbul-lib-instrument": "^6.0.3",
    "jasmine-core": "~6.3.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.3.0",
    "postcss": "^8.5.31",
    "tailwindcss": "^4.3.3",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.72.0"
  },
  "overrides": {
    "@angular/fire": {
      "@angular/common": "$@angular/common",
      "@angular/core": "$@angular/core",
      "@angular/platform-browser": "$@angular/platform-browser",
      "@angular/platform-browser-dynamic": "$@angular/platform-browser-dynamic",
      "firebase": "$firebase"
    }
  },
  "allowScripts": {
    "@firebase/util": true,
    "@parcel/watcher": true,
    "core-js": true,
    "lmdb": true,
    "msgpackr-extract": true,
    "re2": true,
    "esbuild": true,
    "protobufjs": true,
    "@sentry/cli": true,
    "fsevents@2.3.3": true
  }
}
